import { Label } from 'src/app/display/label';
import { DesignData } from '../design/design.data';
import { LayerData } from '../layer/layer.data';
import { SVGShapeLayerData } from '../layer/svg-shape-layer.data';
import { TemplateData } from '../template/template.data';
import { ContextData } from 'src/app/data/context.data';
import { EventEmitter } from '@angular/core';
import { LabelEvent } from 'src/app/events/label.event';
import { Subscription } from 'rxjs';
import { HistoryData } from '../history.data';

export class LabelData {

  // template
  private  _templateData:TemplateData;

  // design
  private _design:DesignData;

  // label
  private _label: Label;

  // layers
  private _layers:Array<LayerData>;
  // Subscriptions
  private _subs: Array<{layerData:LayerData, subs:Subscription}>;


  // On change
  public onChange: EventEmitter<LabelEvent> = new EventEmitter<LabelEvent>();

  /**
   * Contructor
   */
  constructor() {
    this._layers = [];
    this._subs = [];
    this._label = new Label(this);
  }

  /**
   * Template
   */
  public get templateData():TemplateData {
    return this._templateData;
  }
  public set templateData(value:TemplateData) {
    this._templateData = value;
  }

  /**
   * Design
   */
  public get design():DesignData {
    return this._design;
  }
  public set design(value:DesignData) {
    this._design = value;
    if (this._design) {
      for (var i:number = 0; i < this._design.length; i++) {
        let _layer = this._design.getLayer(i);
        if(_layer) this.addLayer(_layer);
      }
    } else {
      if (this._templateData.logo) {
        var locks:any = { position:true, rotation:true, size:true, deletion:false, depth:false, tint:true, colorList:null };

        var layerData: LayerData = new SVGShapeLayerData(ContextData.LOGO_PATH, null, null, this._templateData.logo.x, this._templateData.logo.y, this._templateData.logo.width, this._templateData.logo.height, this._templateData.logo.rotation, 1, locks, LayerData.DESIGN);
        layerData.special = "logo";
        this.addLayer(layerData);
      }
    }
  }

  /**
   * Set data
   */
  public setData(templateData: TemplateData, designData: DesignData):Promise<boolean[]> {
      this.templateData = templateData;
      this._design = designData;
      let promises: Array<Promise<boolean>> = [];

      if (this._design) {
        for (var i: number = 0; i < this._design.length; i++) {
          promises.push(this.addLayer(this._design.getLayer(i)));
        }
      } else {
        if (this._templateData.logo) {
          var locks: any = { position: true, rotation: true, size: true, deletion: false, depth: false, tint: true, colorList: null };
          var layerData: LayerData = new SVGShapeLayerData(ContextData.LOGO_PATH, ContextData.LOGO_SVG, null, this._templateData.logo.x, this._templateData.logo.y, this._templateData.logo.width, this._templateData.logo.height, this._templateData.logo.rotation, 1, locks, LayerData.DESIGN);
          layerData.special = "logo";
          promises.push(this.addLayer(layerData));
        } else {
          this.onChange.emit(new LabelEvent(LabelEvent.INIT_EMPTY, null));
        }
      }

      return Promise.all(promises);
  }

  /**
   * Add Layer
   */
  public addLayer(layer: LayerData): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (layer.index >= 0) {
        for (var i:number = 0; i < this._layers.length; i++) {
          if (this._layers[i].index >= layer.index) {
            this._layers[i].index++;
          }
        }
        this._layers.push(layer);
      } else {
        this._layers.push(layer);
        if (this._layers.length >= 2 && this._layers[this._layers.length - 2].special == "logo") {
          layer.index = this._layers.length - 2;
          this._layers[this._layers.length - 2].index = this._layers.length - 1;
        } else {
          layer.index = this._layers.length - 1;
        }
      }

      if (layer.special == "background" && layer.type == LayerData.SQUARE_SHAPE) {
        layer.width = this._templateData.pixelsWidth;
        layer.height = this._templateData.pixelsHeight;
      }

      //this._label.addLayer(layer);




      this._subs.push({
        layerData: layer,
        subs: layer.onChange.subscribe({
          next: (event: LabelEvent) => {
            this.onChange.emit(new LabelEvent(LabelEvent.CHANGE, layer));
          }
        })
      });

      this.reorderTab();

      this.label.addLayer(layer).then(
        (result: any) => {
          this.onChange.emit(new LabelEvent(LabelEvent.ADD_LAYER, layer));
          resolve(true);
        },
        (error: any) => {
          reject(false);
        }
      ).catch((e: Error) => { console.error(e); reject(e); });
    });
  }

  /**
   * Reorder tab
   */
  public reorderTab(triggerUpdate:boolean = false):void {
    // console.log("LabelData.reorderTab()",this._layers,this._subs);

    var temp:Array<LayerData> = [];
    var temp2: Array<any> = [];
    for (var i:number = 0; i < this._layers.length; i++) {
      temp.splice(this._layers[i].index, 0, this._layers[i]);
      temp2.splice(this._layers[i].index, 0, this._subs[i]);
    }
    this._layers = temp;
    this._subs = temp2;

    if (triggerUpdate) {
      this.onChange.emit(new LabelEvent(LabelEvent.REORDER_LAYERS, null));
    }
  }

  /**
		 * Remove Layer
		 */
  public removeLayer(layerData: LayerData): void {
    // console.log("LabelData.removeLayer()", this._layers,this._subs);
    var sup: number = 0;
    var idx: number;
    for (var i: number = 0; i < this._layers.length; i++) {
      if (this._layers[i].index == layerData.index) {
        idx = i;
        this._subs[i].subs.unsubscribe();
        sup = 1;
      } else {
        this._layers[i].index = i - sup;
      }
    }
    this._layers.splice(idx, 1);
    this._subs.splice(idx, 1);
    this.reorderTab();
    this.onChange.emit(new LabelEvent(LabelEvent.REMOVE_LAYER, layerData));
    layerData.cleanup();
  }

  /**
   * Remove all layer
   */
  public removeAllLayers(): void {
    for (var i: number = 0; i < this._layers.length; i++) {
      if (this._subs[i]) {
        this._subs[i].subs.unsubscribe();
      }
      HistoryData.deleteLayer(this._layers[i]);
      this.onChange.emit(new LabelEvent(LabelEvent.REMOVE_LAYER, this._layers[i]));
      this._layers[i].cleanup();
    }
    this._layers = [];
    this._subs = [];
  }

  /**
   * Label
   */
  get label(): Label {
    return this._label;
  }

  /**
		* width
		*/
  get width(): number {
    return this._templateData.width;
  }
  get pixelsWidth(): number {
    return this.width * ContextData.MM_TO_PIXELS;
  }

  /**
   * height
   */
  get height(): number {
    return this._templateData.height;
  }
  get pixelsHeight(): number {
    return this.height * ContextData.MM_TO_PIXELS;
  }

  /**
   * Layers
   */
  get layers(): Array<LayerData> {
    return this._layers;
  }

  set layers(value: Array<LayerData>) {
    for (let layer of value) {
      if (layer.source != LayerData.DESIGN) {
        layer.source = LayerData.DUPLICATION;
      }
      this.addLayer(layer).then();
    }
  }

  /**
		 * Clone
		 */
  public cloneLayers(): Array<LayerData> {
    var clone: Array<LayerData> = [];
    var layer: LayerData;

    for (let layer of this.layers) {
      clone.push(layer.clone(true));
    }

    return clone;
  }

  /**
	 * Get data
	 */
  public getData(): any {
    var returnData: Array<any> = [];
    for (let layerData of this.layers) {
      returnData.push(layerData.getData());
    }

    return { layers: returnData};
  }

  /**
   * Cleanup
   */
  public cleanup():void {

  }
}
